import React, { useState } from 'react';
import { CopyIcon, CheckIcon } from '../../../assets/icons';
import { vibrate } from '../../../utils/helpers';
import { formatUserId } from '../../../utils/formatters';
import { useNotification } from '../../../context/NotificationContext';
import './ReferralLink.css';

const ReferralLink = ({ userId }) => {
  const [copiedLeft, setCopiedLeft] = useState(false);
  const [copiedRight, setCopiedRight] = useState(false);
  const { success } = useNotification();

  const getRefLink = (position) => {
    const base = window.location.origin + window.location.pathname;
    return `${base}#/register?ref=${userId}&pos=${position}`;
  };

  const handleCopy = async (position) => {
    const link = getRefLink(position);
    try {
      await navigator.clipboard.writeText(link);
      vibrate(50);
      success(`${position === 'left' ? 'Left' : 'Right'} referral link copied!`);
      
      if (position === 'left') {
        setCopiedLeft(true);
        setTimeout(() => setCopiedLeft(false), 2000);
      } else {
        setCopiedRight(true);
        setTimeout(() => setCopiedRight(false), 2000);
      }
    } catch (err) {
      console.error('Copy failed', err);
    }
  };

  return (
    <div className="referral-link-card">
      <div className="referral-link-header">
        <span className="referral-link-label">Your Referral Links</span>
        <span className="referral-id">ID: {formatUserId(userId)}</span>
      </div>
      
      <div className="referral-links-container">
        <div className="ref-link-item left">
          <div className="ref-link-title">
            <span className="ref-icon">⬅️</span>
            <span>Left Team</span>
          </div>
          <div className="ref-link-url">{getRefLink('left').slice(-35)}...</div>
          <button 
            className={`ref-link-copy-btn ${copiedLeft ? 'copied' : ''}`}
            onClick={() => handleCopy('left')}
          >
            {copiedLeft ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
            {copiedLeft ? 'Copied!' : 'Copy Link'}
          </button>
        </div>

        <div className="ref-link-item right">
          <div className="ref-link-title">
            <span className="ref-icon">➡️</span>
            <span>Right Team</span>
          </div>
          <div className="ref-link-url">{getRefLink('right').slice(-35)}...</div>
          <button 
            className={`ref-link-copy-btn ${copiedRight ? 'copied' : ''}`}
            onClick={() => handleCopy('right')}
          >
            {copiedRight ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
            {copiedRight ? 'Copied!' : 'Copy Link'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReferralLink;
